export default {"src":"/_next/static/media/HOOD.bda03d48.svg","height":18,"width":18};